import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ eyebrow, title, description, align = "left", light = false }) => (
    <Reveal className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
        <p className="eyebrow">{eyebrow}</p>
        <h2 className={`mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight leading-snug ${light ? "text-ivory" : "text-navy"}`}>
            {title}
        </h2>
        <div className={`gold-rule mt-6 ${align === "center" ? "mx-auto" : ""}`} />
        {description ? (
            <p className={`mt-6 text-base leading-relaxed ${light ? "text-ivory/70" : "text-steel"}`}>{description}</p>
        ) : null}
    </Reveal>
);
